import type {
  InsightExplorerDistributionResponse,
  InsightExplorerTrendResponse,
} from '@/features/InsightExplorer/types/types';
import useColor from '@/hooks/domain/useColor';

import CardContainer from '../../CardContainer';
import VolumeTrendBySubtopicsSection from './VolumeTrendBySubtopicsSection';

interface Props {
  childrenData: InsightExplorerDistributionResponse;
  data?: InsightExplorerTrendResponse;
}

const VolumeTrendBySubtopicsContainer = (props: Props) => {
  const color = useColor();
  const { childrenData, data } = props;

  return (
    <CardContainer style={{ borderColor: color.gray250, padding: '20px' }}>
      <VolumeTrendBySubtopicsSection
        distributionTargets={childrenData.map((child) => child.alias)}
        data={data}
      />
    </CardContainer>
  );
};

export default VolumeTrendBySubtopicsContainer;
